/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { NotificationCategoryFromJSON, NotificationCategoryToJSON, } from './NotificationCategory';
/**
 * Check if a given object implements the NotificationPreferenceDto interface.
 */
export function instanceOfNotificationPreferenceDto(value) {
    let isInstance = true;
    return isInstance;
}
export function NotificationPreferenceDtoFromJSON(json) {
    return NotificationPreferenceDtoFromJSONTyped(json, false);
}
export function NotificationPreferenceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': !exists(json, 'category') ? undefined : NotificationCategoryFromJSON(json['category']),
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isTransactional': !exists(json, 'isTransactional') ? undefined : json['isTransactional'],
        'emailEnabled': !exists(json, 'emailEnabled') ? undefined : json['emailEnabled'],
        'inAppAvailable': !exists(json, 'inAppAvailable') ? undefined : json['inAppAvailable'],
        'inAppEnabled': !exists(json, 'inAppEnabled') ? undefined : json['inAppEnabled'],
    };
}
export function NotificationPreferenceDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': NotificationCategoryToJSON(value.category),
        'displayName': value.displayName,
        'description': value.description,
        'isTransactional': value.isTransactional,
        'emailEnabled': value.emailEnabled,
        'inAppAvailable': value.inAppAvailable,
        'inAppEnabled': value.inAppEnabled,
    };
}
